import {Badge} from "@mantine/core";
import {
    CustomerSubscription,
    CustomerSubscriptionStatus
} from "../types.ts";

export const SubscriptionStatusBadge = ({record}: { record: CustomerSubscription }) => {

    let color = '';

    const message = record.status ? record.status : 'n/a';

    if (record.status === CustomerSubscriptionStatus.Active) {
        color = 'green';
    } else if (record.status === CustomerSubscriptionStatus.Inactive) {
        color = 'gray';
    } else {
        color = 'red';
    }
    return <Badge color={color}>{message}</Badge>;
};
